// extracted by mini-css-extract-plugin
export default {"cls1":"jtdllxlW3iKNYuoWADXg","cls2":"wNxcV_Sn_Govka5yWFPO jtdllxlW3iKNYuoWADXg"};